import { Form } from 'react-bootstrap';

const SendMail = ({ state, onChange }: any) => {
  const { subject, mailBody, sendToAddress, sendToCC, attachments } = state.config || {};

  return (
    <>
      <Form.Group className="mb-2 w-full" controlId="formNode-subject">
        <Form.Label>Subject</Form.Label>
        <Form.Control type="text" name="subject" value={subject} onChange={(e) => onChange(e, true)} />
      </Form.Group>
      <Form.Group className="mb-2 w-full" controlId="formNode-mailBody">
        <Form.Label>Mail body</Form.Label>
        <Form.Control type="text" as="textarea" rows={3} name="mailBody" value={mailBody} onChange={(e) => onChange(e, true)} aria-label="With textarea" />
      </Form.Group>
      <Form.Group className="mb-2 w-full" controlId="formNode-sendToAddress">
        <Form.Label>Send to address</Form.Label>
        <Form.Control type="text" name="sendToAddress" value={sendToAddress} onChange={(e) => onChange(e, true)} />
      </Form.Group>
      <Form.Group className="mb-2 w-full" controlId="formNode-sendToCC">
        <Form.Label>CC address</Form.Label>
        <Form.Control type="text" name="sendToCC" value={sendToCC} onChange={(e) => onChange(e, true)} />
      </Form.Group>
      <Form.Group className="mb-2 w-full" controlId="formNode-attachments">
        <Form.Label>Attachments</Form.Label>
        <Form.Control
          type="text"
          name="attachments"
          value={attachments}
          onChange={(e) => onChange(e, true)}
          placeholder="node_file(node-1, stdout.txt), report.pdf=node_file(node-2, output.csv)"
        />
        <Form.Text className="text-muted">
          Comma-separated. Use node_file(node_id, filename) to attach output from another node in the flow. The node ID is shown on each node (e.g., &quot;ID:
          node-2&quot;). Optionally prefix with attachment_name= to rename.
        </Form.Text>
      </Form.Group>
    </>
  );
};

export default SendMail;
